import { LIST_OPTIONS } from '../../constants/pouchDB';
import { findUserDocs } from '../../handlers/userDB';
import { addFilter } from '../pouchDB/documents';

export const fetchFileIdsBySeries = seriesId => async (dispatch) => {
    const optEpisodes = {
        ...addFilter(LIST_OPTIONS.episodes, 'seriesId', seriesId, '$eq'),
        fields: ['videoId']
    };
    const episodes = await dispatch(findUserDocs(optEpisodes));

    return episodes.map(ep => ep.videoId);
};
